  const Settings = {
            //  serverUrl: "http://192.168.1.2:5000/",
            serverUrl:"https://restock-01.herokuapp.com/",
            //serverUrl:"http://restockapi-officeware.rhcloud.com/",
           //  imagesUrl: "http://localhost:8080/static/",
            imagesUrl: "https://restock.gitlab.io/static/",
          
                                          }

export default Settings



// WEBPACK FOOTER //
// ./src/modules/settings.js